<template>
  <div class="activities">
    <div class="title">
      <div></div>
      icon列表
    </div>
    <div class="query">
      <div class="query-box">
        <el-input v-model="query" placeholder="酒吧名称"></el-input>
      </div>

      <el-button type="primary" @click="inquire">查询</el-button>
      <el-button type="primary" @click="addShow = true">新增</el-button>
      <el-button type="primary" @click="down">下载模板</el-button>
      <el-button type="primary" @click="toLead">导入</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column align="center" prop="barName" label="酒吧名称">
        </el-table-column>

        <el-table-column align="center" prop="startTime" label="icon开始时间">
        </el-table-column>
        <el-table-column align="center" prop="endTime" label="icon结束时间">
        </el-table-column>

        <el-table-column align="center" prop="" label="icon图片">
          <template slot-scope="images">
            <el-image
              style="width: 50px; height: 50px"
              class="table-td-thumb"
              :src="images.row.icon"
              :preview-src-list="[images.row.icon]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="activityEdit(scope.row)"
              >编辑</el-button
            >
            <!-- <el-button size="mini" type="danger" @click="del(scope.row.id)"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1, 3, 5, 10]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新增 -->

    <el-dialog
      title="新增/编辑"
      :visible.sync="addShow"
      width="50%"
      @closed="handleClose"
    >
      <div class="main">
        <el-form ref="forms" :model="form" label-width="170px" :rules="rules">
          <el-form-item label="酒吧id" prop="barId">
            <el-input v-model="form.barId" placeholder="酒吧id"></el-input>
          </el-form-item>
          <el-form-item
            label="上传icon（1张）"
            label-position="right"
            class="form-label"
            prop="icon"
          >
            <el-upload
              class="avatar-uploader"
              :action="imgURL"
              :show-file-list="false"
              :on-success="iconSuccess"
            >
              <img
                style="width: 100px; height: 100px"
                v-if="form.icon"
                :src="form.icon"
                class="avatar"
              />
              <i
                style="width: 100px; height: 100px"
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="icon有效期" prop="activityTime">
            <el-date-picker
              format="yyyy-MM-dd HH:mm"
              v-model="form.activityTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addShow = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit('forms')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <input
      ref="excel-upload-input"
      class="excel-upload-input"
      type="file"
      accept=".xlsx, .xls"
      @change="handleClick"
    />
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import {
  listBarIcon,
  saveOrUpd,
  IP,
  functiondownload,
  importBarIcon,
} from "@/api/api";
import reg from "@/utils/reg.js";
export default {
  data() {
    return {
      ruleList: [],
      query: "",
      imgURL: IP + "/images/uploadImage",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],

      addShow: false,
      form: {
        activityTime: [],
        barId: "", //活动名称
        startTime: "",
        endTime: "",
        icon: "",
        id: "",
      },
      rules: {
        //验证规则
        barId: [{ required: true, message: "请输入酒吧id", trigger: "blur" }],
        activityTime: [
          { required: true, message: "请选择活动时间", trigger: "blur" },
        ],
        icon: [
          {
            required: true,
            message: "请输入上传icon图片",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 导入
    toLead() {
      this.$refs["excel-upload-input"].click();
    },
    async handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0];
        var formData = new FormData()
        formData.append('file', rawFile)

      let { code, msg } = await importBarIcon(formData);
      if (code == 200) {
          this.$message({
              type: "success",
              message: "导入成功!",
            });
          this.getList();
       }
    },
    // 下载模板
    down() {
      // IMPORT_BAR_ICON 导入酒吧icon
      // BATCH_IMPORT_BAR 批量导入酒吧
      functiondownload(
        "/web/bar/downloadModel",
        {
          modelType: "IMPORT_BAR_ICON",
        },
        true
      );
    },
    // 上传icon
    iconSuccess(e) {
      console.log(e);
      this.form.icon = e;
    },
    // 编辑
    activityEdit(res) {
      res.activityTime = ["", ""];
      res.activityTime[0] = new Date(res.startTime);
      res.activityTime[1] = new Date(res.endTime);
      this.form = { ...res };
      this.addShow = true;
    },
    // 新增
    addSubmit: reg._debounce(function (formName) {
      (this.form.startTime = moment(this.form.activityTime[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      )),
        (this.form.endTime = moment(this.form.activityTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        ));
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { code, msg } = await saveOrUpd({
            barId: this.form.barId,
            icon: this.form.icon,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            id: this.form.id,
          });

          if (code == 200) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.addShow = false;
            this.getList();
          }
        }
      });
    }, 200),
    // 关闭弹窗
    handleClose() {
      this.addShow = false;
      this.form = {
        activityTime: "",
        barId: "", //活动名称
        startTime: "",
        endTime: "",
        icon: "",
        id: "",
      };
    },
    // 删除活动
    del(id) {
      this.$confirm("将删除此活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await delActivity({
            id: id,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //  获取活动列表
    async getList() {
      let res = await listBarIcon({
        barName: this.query,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      });
      console.log(res);
      let { data } = res;
      //  边界判断
      if (!data.list.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.list;
      this.total = data.total;
    },

    // 查询
    inquire() {
      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.startTime = "";
      this.endTime = "";
      this.activityTime = "";
      this.getList();
    },

    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
.active {
  color: #33b959;
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
/deep/.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  line-height: 100px;
  vertical-align: top;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
/deep/.el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;
}
.excel-upload-input{
    position: relative;
    z-index: -1;
}
</style>